import { Box, RadioButton, Text } from '@origin-digital/style-guide';
import * as React from 'react';
import analytics from '../../../../analytics';
import FieldError from '../FieldError';

import { RadioGroupProps } from './RadioGroup.types';
import { SolarIcon } from '../../../../apps/SolarContact/components/Navigation/SolarIcon';

const RadioGroup: React.StatelessComponent<RadioGroupProps> = ({ ...props }: RadioGroupProps): JSX.Element | null => {
  const { name, options, isValid, maxWidth, arrayHelpers, HOCHandler, onFieldChange } = props;
  const { form } = arrayHelpers;
  const hasError = form.errors[name] || false;

  if (!options) {
    return null;
  }

  const onSelect = (value: string): void => {
    if (!form.values[name]) {
      form.values[name] = [];
    }

    if (form.values[name][0] !== value) {
      if (HOCHandler) {
        HOCHandler(value);
      }

      if (onFieldChange) {
        onFieldChange(name, value);
      }

      arrayHelpers.push(value);
      form.setFieldValue(name, value, false);
      form.setFieldTouched(name, true, false);
    }

    analytics.radioSelect(name, value);
  };

  return (
    <React.Fragment>
      <Box direction="row" display={'block'} flex="grow" maxWidth={maxWidth || 500} flexWrap={true} marginBottom={3}>
        {options.map((option, i) => {
          const checked = form.values[name] === option.value;
          return (
            <Box key={`${i}${option.value}`} data-id={option.value} padding={4} onClick={() => onSelect(option.value)}>
              <RadioButton
                helpText={option.byline}
                name={name}
                checked={checked}
                label={
                  option.icon ? (
                    <Box alignItems="center" direction="row" display="flex">
                      <Box marginRight={4}>
                        <SolarIcon iconType={option.icon} />
                      </Box>
                      <Text size={'sm'}>{option.label}</Text>
                    </Box>
                  ) : (
                    option.label
                  )
                }
                onClick={() => {}}
              />
            </Box>
          );
        })}
      </Box>
      {hasError &&
        !isValid && (
          <Box marginLeft={3}>
            <FieldError name={name} error={name} />
          </Box>
        )}
    </React.Fragment>
  );
};

export { RadioGroup as default };
